var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgIndirectUser(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.182 11.056a8.623 8.623 0 01-1.57 4.967 8.188 8.188 0 01-4.1 3.06 7.925 7.925 0 01-5.06-.021 8.193 8.193 0 01-4.078-3.093 8.627 8.627 0 01-1.532-4.98 8.62 8.62 0 011.6-4.955A8.182 8.182 0 017.563 3a7.925 7.925 0 015.06.054 8.207 8.207 0 014.025 3.078 8.638 8.638 0 011.535 4.923z",
    fill: "#536AEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.218 10.01a8.218 8.218 0 11-16.436.008 8.218 8.218 0 0116.436-.008z",
    fill: "#798BF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.966 4.364l-12.97 9.947a8.218 8.218 0 0112.97-9.947z",
    fill: "#9AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.092 4.678v.433a1.016 1.016 0 01-.638.954 1.844 1.844 0 00-1.196 1.719v4.602a.293.293 0 00.29.289h.874a.328.328 0 01.25.555l-1.973 2.534a.517.517 0 01-.815 0L5.536 14.05l-.657-.825a.329.329 0 01.256-.53h.871a.292.292 0 00.293-.292V7.8a3.8 3.8 0 013.152-3.74.569.569 0 01.641.618zM14.858 7.322h-.87a.29.29 0 00-.29.293v4.601a3.8 3.8 0 01-3.152 3.738.566.566 0 01-.641-.615v-.434a1.022 1.022 0 01.637-.95 1.831 1.831 0 001.197-1.719V7.634a.293.293 0 00-.29-.289h-.874a.329.329 0 01-.246-.559L12.3 4.252a.517.517 0 01.812 0l1.292 1.644.703.897a.328.328 0 01-.25.53z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1.797)",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgIndirectUser;